import { Injectable } from '@angular/core';
import { Subject, Observable } from "rxjs";
import { Notification } from "@app/secure/model/Notification";
import { NotificationType } from "@app/secure/model/NotificationType";

@Injectable()
export class NotificationService 
{
    private subject = new Subject<Notification>();
    private idx = 0;

    constructor() { }

    getObservable(): Observable<Notification> 
    {
        return this.subject.asObservable();
    }

    info
    (
        title: string, 
        message: string, 
        timeout = 1000
    ) 
    {
        this.subject.next(new Notification(this.idx++, 
                                           NotificationType.INFO, title, 
                                           message, timeout));
    }

    success
    (
        title: string, 
        message: string, 
        timeout = 3000
    ) 
    {
        this.subject.next(new Notification(this.idx++, 
                                            NotificationType.SUCCESS, 
                                            title, message, timeout));
    }

    warning
    (
        title: string, 
        message: string, 
        timeout = 3000
    ) 
    {
        this.subject.next(new Notification(this.idx++, 
                                           NotificationType.WARNING, 
                                         title, message, timeout));
    }

    error
    (
        title: string, 
        message: string, 
        timeout = 0
    ) 
    {
        this.subject.next(new Notification(this.idx++, 
                                           NotificationType.ERROR, 
                                           title, message, timeout));
    }
}